import { ConversationStatus } from '@provision/conversation-types';
import { Conversation, useGroupRules, UserGroupRules } from 'src/graphql';

/** Why the composer gives way to a state panel; none means the composer is shown. */
export enum ConversationFooterState {
  Deleted = 'deleted',
  Closed = 'closed',
  ReadOnly = 'readOnly',
}

export function useConversationFooterState(
  conversation: Pick<Conversation, 'isDeleted' | 'conversationStatusId'>,
): ConversationFooterState | null {
  const { checkValidity } = useGroupRules();

  if (conversation.isDeleted) return ConversationFooterState.Deleted;
  if (
    (conversation.conversationStatusId as ConversationStatus) === ConversationStatus.Closed
  ) {
    return ConversationFooterState.Closed;
  }
  if (!checkValidity([UserGroupRules.AccessToUpdateConversation])) {
    return ConversationFooterState.ReadOnly;
  }
  return null;
}
